import { render, staticRenderFns } from "./TransactionsClient.vue?vue&type=template&id=5e0e73e8&scoped=true&"
import script from "./TransactionsClient.vue?vue&type=script&lang=js&"
export * from "./TransactionsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e73e8",
  null
  
)

export default component.exports